
class PaymentInstallmentTemplateLineCell extends UITableViewCell
{
    private daysTextField:MUITextField = null;
    private percentageTextField:MUITextField = null;

    private nf = MUIWebApplication.sharedInstance().delegate.numberFormatter as MIONumberFormatter;

    awakeFromHTML(){
        this.daysTextField = MUIOutlet(this, "days-tf", "MUITextField");
        this.daysTextField.setOnChangeText(this, function(this:PaymentInstallmentTemplateLineCell, control:MUITextField, value:string){
            let days = this.nf.numberFromString(value);
            this._item.offsetDays = days != null ? days : 0;
        });

        this.percentageTextField = MUIOutlet(this, "percentage-tf", "MUITextField");
        this.percentageTextField.setOnChangeText(this, function(this:PaymentInstallmentTemplateLineCell, control:MUITextField, value:string){
            let percentage = this.nf.numberFromString(value);
            this._item.percentage = percentage != null ? percentage : 0;
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    private _item:PaymentInstallmentTemplateLine = null;
    set item(item:PaymentInstallmentTemplateLine){
        this._item = item;

        this.daysTextField.text = this.nf.stringFromNumber(item.offsetDays);
        this.percentageTextField.text = this.nf.stringFromNumber(item.percentage);
    }
}
